import { useEffect } from "react";
import "./styles.css";

export const NotFound = () => {
  useEffect(() => {
    const nfError = new Error('Ошибка! Страница не найдена')
    nfError.code = 404
    throw nfError
  })

  return (
    <div className="page">
      <div className="error">
        <p className="error__code">404</p>
        <h1 className="error__title">Not Found</h1>
      </div>
    </div>
  );
};
